import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function LandCrop() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [farmlandList, setFarmlandList] = useState([]);
    const [varietyList, setVarietyList] = useState([]);
    const [editId, setEditId] = useState("");
    const [formData, setFormData] = useState({
        land: "",
        variety: "",
        cultivated_area: "",
        unit: "Acre",
        sowing_date: "",
        expected_harvest_date: "",
        actual_harvest_date: "",
        expected_yield: "",
        actual_yield: "",
        status: "PLANNED",
        remarks: "",
        addedby: userName,
        ip_add: ipAddress
    });
    const formatDate = (date) => {
        if (!date) return "";
        return date.substring(0, 10);
    };
    useEffect(() => {
        loadData();
        loadFarmland();
        loadVariety();
    }, []);
    const loadData = () => {
        setLoading(true);
        axios.get(baseUrl + "land-crop/")
            .then((res) => {
                setData(res.data);
                setLoading(false);
            });
    };
    const loadFarmland = () => {
        axios.get(baseUrl + "farmland/")
            .then((res) => {
                setFarmlandList(res.data);
            });
    };
    const loadVariety = () => {
        axios.get(baseUrl + "crop-variety/")
            .then((res) => {
                setVarietyList(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
    const payload = {
        ...formData,
        sowing_date: formatDate(formData.sowing_date),
        actual_harvest_date:
            formData.actual_harvest_date || null,
        expected_harvest_date:
            formData.expected_harvest_date || null,
    };
    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        const payload = {
            ...formData,
            sowing_date: formatDate(formData.sowing_date),
            expected_harvest_date: formatDate(formData.expected_harvest_date),
            actual_harvest_date: formatDate(formData.actual_harvest_date),
        };
        if (editId === "") {
            console.log(payload);
            axios.post(baseUrl + "land-crop/", payload)
                .then(() => {
                    Swal.fire("Success", "Saved Successfully", "success");
                    resetForm();
                    loadData();
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire("Error", "Unable to Save", "error");
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            console.log(payload);
            axios.put(baseUrl + `update-land-crop/${editId}/`, payload)
                .then(() => {
                    Swal.fire("Updated", "Updated Successfully", "success");
                    resetForm();
                    loadData();
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire("Error", "Unable to Update", "error");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            land: row.land?.id || "",
            variety: row.variety?.id || "",
            cultivated_area: row.cultivated_area,
            unit: row.unit,
            sowing_date: formatDate(row.sowing_date),
            expected_harvest_date: formatDate(row.expected_harvest_date),
            actual_harvest_date: formatDate(row.actual_harvest_date),
            expected_yield: row.expected_yield,
            actual_yield: row.actual_yield,
            remarks: row.remarks || "",
            status: row.status || "PLANNED",
            addedby: userName,
            ip_add: ipAddress
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete?", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`delete-land-crop/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        loadData();
                    });
            }
        });
    };
    const resetForm = () => {
        setEditId("");
        setFormData({
            land: "",
            variety: "",
            cultivated_area: "",
            unit: "Acre",
            sowing_date: "",
            expected_harvest_date: "",
            actual_harvest_date: "",
            expected_yield: "",
            actual_yield: "",
            status: "PLANNED",
            remarks: "",
            addedby: userName,
            ip_add: ipAddress
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 70
    }, {
        field: "land_name",
        headerName: "Farmland",
        width: 220,
        renderCell: (params) => (params.row.land?.land_name || "-")
    }, {
        field: "variety_name",
        headerName: "Crop Variety",
        width: 220,
        renderCell: (params) => (params.row.variety?.variety_name || "-")
    }, {
        field: "crop_name",
        headerName: "Crop",
        width: 180,
        renderCell: (params) => (params.row.variety?.crop?.name || "-")
    }, {
        field: "owner_name",
        headerName: "Land Owner",
        width: 220,
        renderCell: (params) => (params.row.land?.owner?.name || "-")
    }, {
        field: "village", headerName: "Village", width: 170, renderCell: (params) => (params.row.land?.village || "-")
    }, {
        field: "extent",
        headerName: "Extent",
        width: 130,
        renderCell: (params) => (`${params.row.land?.extent ?? ""} ${params.row.land?.unit ?? ""}`)
    }, {
        field: "cultivated_area", headerName: "Cultivated", width: 150
    }, {
        field: "status", headerName: "Status", width: 140
    }, {
        field: "actions", headerName: "Actions", width: 170, sortable: false, renderCell: (params) => (<>
            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editData(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm"
                onClick={() => deleteData(params.row.id)}
            >
                Delete
            </button>
        </>)
    }];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">
                        Land Crop Management
                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Farmland
                                </label>

                                <select
                                    className="form-control"
                                    name="land"
                                    value={formData.land}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Farmland
                                    </option>

                                    {farmlandList.map((item) => (<option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.land_name}
                                        </option>))}

                                </select>

                            </div>

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Crop Variety
                                </label>

                                <select
                                    className="form-control"
                                    name="variety"
                                    value={formData.variety}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Crop Variety
                                    </option>

                                    {varietyList.map((item) => (<option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.variety_name}
                                        </option>))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Cultivated Area</label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="cultivated_area"
                                    value={formData.cultivated_area}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Unit</label>

                                <select
                                    className="form-control"
                                    name="unit"
                                    value={formData.unit}
                                    onChange={handleChange}
                                >

                                    <option value="Acre">Acre</option>
                                    <option value="Hectare">Hectare</option>

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Sowing Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="sowing_date"
                                    value={formData.sowing_date}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Expected Harvest</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="expected_harvest_date"
                                    value={formData.expected_harvest_date}
                                    onChange={handleChange}
                                />

                            </div>
                            <div className="col-md-3 mb-3">

                                <label>Actual Harvest</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="actual_harvest_date"
                                    value={formData.actual_harvest_date}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Expected Yield</label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="expected_yield"
                                    value={formData.expected_yield}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Actual Yield</label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="actual_yield"
                                    value={formData.actual_yield}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Crop Status</label>

                                <select
                                    className="form-control"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >
                                    <option value="PLANNED">Planned</option>
                                    <option value="SOWN">Sown</option>
                                    <option value="GROWING">Growing</option>
                                    <option value="HARVESTED">Harvested</option>
                                    <option value="FAILED">Failed</option>
                                </select>

                            </div>

                            <div className="col-md-12 mb-3">

                                <label>Remarks</label>

                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-12">

                                <button
                                    type="submit"
                                    className="btn btn-success me-2"
                                    disabled={loading}
                                >
                                    {editId === "" ? "Save" : "Update"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={resetForm}
                                >
                                    Clear
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Land Crop List
                    </h5>

                </div>

                <div className="card-body">

                    <div style={{height: 600, width: "100%"}}>

                        <ERPDataGrid
                            rows={data}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}

                        />

                    </div>

                </div>

            </div>

        </div>);
}
export default LandCrop;